"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var CoolServerStorage = (function () {
    function CoolServerStorage() {
        this._storageObject = {};
    }
    CoolServerStorage.prototype.getItem = function (key) {
        return this._storageObject[key] || null;
    };
    CoolServerStorage.prototype.setItem = function (key, value) {
        this._storageObject[key] = value;
    };
    CoolServerStorage.prototype.removeItem = function (key) {
        this._storageObject[key] = undefined;
    };
    CoolServerStorage.prototype.key = function (index) {
        return this._storageObject.key(index);
    };
    CoolServerStorage.prototype.clear = function () {
        this._storageObject = {};
    };
    Object.defineProperty(CoolServerStorage.prototype, "length", {
        get: function () {
            return Object.keys(this._storageObject).length;
        },
        enumerable: true,
        configurable: true
    });
    return CoolServerStorage;
}());
exports.CoolServerStorage = CoolServerStorage;
//# sourceMappingURL=cool-server-storage.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/angular2-cool-storage/src/cool-server-storage.js
// module id = 826
// module chunks = 3